export const UNAVAILABLE = 'N/A';
